import React from 'react';
import { Box, Typography } from '@mui/material';

const AuthError: React.FC = () => {
  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        height: '100vh',
        justifyContent: 'center',
      }}
    >
      <Box sx={{ maxWidth: 400, p: 4, textAlign: 'center' }}>
        <Typography variant="h5" component="h1" gutterBottom>
          Authentication Error
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Unable to complete authentication. Please try again or contact your
          administrator.
        </Typography>
      </Box>
    </Box>
  );
};

export default AuthError;
